// Email service that calls Vercel serverless function
// This replaces direct SendGrid calls from the browser

type EmailType = 'welcome' | 'survey' | 'demo';

class EmailService {
  private apiEndpoint: string;

  constructor() {
    // In production, this will be your Vercel domain
    // In development, it will be localhost:3000
    this.apiEndpoint = process.env.REACT_APP_API_URL || '/api/send-email';
  }

  async sendEmail(email: string, type: EmailType, name?: string): Promise<boolean> {
    try {
      const response = await fetch(this.apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          name: name || '',
          type
        })
      });

      if (response.ok) {
        console.log(`${type} email sent successfully`);
        return true;
      } else {
        // Only try to parse JSON if there's content
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          console.error(`Failed to send ${type} email:`, errorData);
        } else {
          const errorText = await response.text();
          console.error(`Failed to send ${type} email:`, errorText);
        }
        return false;
      }
    } catch (error) {
      console.error(`Error sending ${type} email:`, error);
      return false;
    }
  }

  async sendWelcomeEmail(email: string, name?: string): Promise<boolean> {
    return this.sendEmail(email, 'welcome', name);
  }

  async sendSurveyFollowup(email: string, name?: string): Promise<boolean> {
    return this.sendEmail(email, 'survey', name);
  }

  async sendDemoFollowup(email: string, name?: string): Promise<boolean> {
    return this.sendEmail(email, 'demo', name);
  }

  // Test email configuration
  async testEmailConfiguration(): Promise<boolean> {
    try {
      console.log('Email service configured via Vercel serverless function');
      return true;
    } catch (error) {
      console.error('Email service configuration test failed:', error);
      return false;
    }
  }
}

export const emailService = new EmailService();

